import { BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_link, CCTM_nav, CCTM_route, NavLink, useCCTM } from "@bcm-dev/bcms-vite";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function LoginNavigation
 * @exported true
 * @returns {React.Component}
 * @description The container component for all Login Navigation Items.
 */
export function LoginNavigation(props) {

    const xml =  useCCTM(),
              menu = <CCTM nav-id={"loginBottomNav"} xml={xml} self={LoginNavigationWrapper}>
                          <CCTM_nav component={LoginNavigationWrapper}/>                            
                          <CCTM_route component={LoginNavigationItem}/>                  
                          <CCTM_link component={LoginNavigationItem}/> 
                          <CCTM_item component={LoginNavigationItem}/>                                             
                          <CCTM_demo component={LoginNavigationItem} /> 
                                    
                      </CCTM>;
  return menu;  
}

/**
 * @function LoginNavigationWrapper
 * @exported true
 * @returns {React.Component}
 * @description The container component for all Login Navigation Items.
 */
export function LoginNavigationWrapper(props) {

return(
  <div className="login-navigation flex-height flex-container flex-horizontal align-bottom">
    <BrandingStyle style={{ "backgroundColor" : "login_nav_bg_mabi23" }}  className="login-items-container flex-container flex-horizontal flex-width space-around">
      {props.children}
    </BrandingStyle>
  </div>
);
}
/**
 * @function LoginNavigationItem
 * @param {STRING} text - Allows us to set the text of the navigation item.
 * @param {STRING} to - Sets the route of the NavLink.
 * @param {STRING} icon - Sets the icon for the navigation item.
 * @returns {React.Component}
 * @exported false
 * @description This is the individual login navigation item component. It includes text and an icon.
 * @example
 * <LoginNavigationItem text="Location" icon="LocationPinIcon" to="/LocationPage" />
 */
function LoginNavigationItem(props) {
  const text = props.label ?? "[text]";
  const to = props.to ?? "";
  const icon = props.asset_name ?? "FaceIDIcon";
  const className = props["custom-class"] ?? "";
  const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};
  const defaultCustomClassesForIcon = "";
  const customClassForIcon = props["asset_custom-class"] 
  ? { className: `${ props["asset_custom-class"] } ${ defaultCustomClassesForIcon }` }
  : {};

  return(
    <BrandingStyle style={{ "color" : "nav_link_icon_mabi23", "fill" : "nav_link_icon_mabi23" }}>
    <NavLink to={ to } className={ className }>
      <div className="login-navigation-item flex-width flex-container flex-vertical align-center justify-right">
        <BrandingStyle 
          style={{ "borderColor" : "nav_link_icon_mabi23" }} 
          className="flex-height icon-container flex-container align-center">
          <BrandingStyle 
            style={{ "fill" : "nav_link_icon_mabi23" }} 
            { ...customClassForIcon }
            element={<SVGAsset id={icon} { ...dataPoint } />} />
        </BrandingStyle>
        <BrandingStyle 
          style={{ "color" : "nav_link_icon_mabi23" }} 
          className="flex-height link-text" 
          element={<p >{text}</p>} />
      </div>
    </NavLink>
    </BrandingStyle>
  );
}